let isConfigured = false;

export function configureFetchCredentials() {
    if (isConfigured || typeof window === "undefined" || !window.fetch) {
        return;
    }

    const originalFetch = window.fetch.bind(window);

    window.fetch = (input, init = {}) => {
        if (!shouldIncludeCredentials(input) || hasExplicitCredentials(init)) {
            return originalFetch(input, init);
        }

        return originalFetch(input, {
            ...init,
            credentials: "include",
        });
    };

    isConfigured = true;
}

function shouldIncludeCredentials(input) {
    const requestUrl = getRequestUrl(input);
    const apiUrl = process.env.REACT_APP_FETCH_URL;

    return Boolean(apiUrl && requestUrl && requestUrl.startsWith(apiUrl));
}

function hasExplicitCredentials(init) {
    return Object.prototype.hasOwnProperty.call(init, "credentials");
}

function getRequestUrl(input) {
    if (typeof input === "string") {
        return input;
    }

    if (input instanceof URL) {
        return input.toString();
    }

    if (typeof Request !== "undefined" && input instanceof Request) {
        return input.url;
    }

    return undefined;
}
